import { h, Component } from 'preact';
import cx from 'classnames';

import style from './style.less';
import CardImage from '../../pieces/card-image';
import { isExternal, getAttribution } from '../../../lib/utils';

import {
	trackingProvider,
	trackProps,
	getTrackingAttributesForAsset,
	DIMENSION
} from '@cube/track';
import { Truncate } from '@cube/blocks';
import { assetLink } from '@cube/utils';

/**
 * A card with an image on top and text below
 * @param {object} asset					the article to display
 * @param {string} theme					light or dark
 * @param {string} cardClass				fully resolved or local class to apply to card
 * @param {integer} titleLines				max number of lines on title
 * @param {boolean} showDescription			display description
 * @param {integer} descriptionLines		max number of lines on description
 * @param {string} attributionOverride		static text to display in place of attribution
 * @param {boolean} hideAttribution   		hide attribution
 */
/**
 * A card with an image and text
 * Layout
 * Image on top of title and attribution
 * @param {Object} asset content for a card
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'SimpleVerticalCard'
})
export default class SimpleVerticalCard extends Component {
	state = {
		isHovered: false
	};

	handleMouseEnter = () => {
		this.setState({ isHovered: true });
	};

	handleMouseLeave = () => {
		this.setState({ isHovered: false });
	};
	static defaultProps = {
		titleLines: 2,
		descriptionLines: 2
	};

	render({
		asset,
		theme,
		cardClass,
		qeId,
		titleLines,
		showDescription,
		descriptionLines,
		attributionOverride,
		hideAttribution,
		imageOnly,
		openExternal,
		...props
	}) {
		return (
			<div
				data-tb-region-item
				class={cx(
					style.simpleVerticalCard,
					style[theme],
					style[cardClass] || cardClass || ''
				)}
				qid={qeId}
				onMouseEnter={this.handleMouseEnter}
				onMouseLeave={this.handleMouseLeave}

			>
				<a
					{...trackProps(getTrackingAttributesForAsset(asset), this.context)}
					href={assetLink(asset)}
					rel={(openExternal||isExternal(asset)) && 'noreferrer noopener'}
					target={(openExternal||isExternal(asset)) && '_blank'}
				>
					<div>
						<CardImage asset={asset} qeId={qeId} hover={this.state.isHovered} {...props} />
						{!imageOnly && (
							<div class={style.metadata}>
								<div class={style.title} qid={qeId + '-title'}>
									<Truncate method="multipleLines" lines={titleLines}>
										{asset.title}
									</Truncate>
								</div>
								{showDescription && (
									<div class={style.description} qid={qeId + '-description'}>
										<Truncate method="multipleLines" lines={descriptionLines}>
											{asset.summary}
										</Truncate>
									</div>
								)}
								{!hideAttribution && (
									<div
										class={cx(
											style.attribution,
											attributionOverride && style.overridden
										)}
										qid={qeId + '-attribution'}
									>
										{attributionOverride || getAttribution(asset)}
									</div>
								)}
							</div>
						)}
					</div>
				</a>
			</div>
		);
	}
}
